import {withRoute} from '@hconnect/uikit'

import LegalDocumentPages from './LegalDocumentPages'

export const ROUTE = '/imprint'

const ImprintPage = () => <LegalDocumentPages legalDocumentType="imprint" />

export default withRoute({
  path: ROUTE,
  label: 'Terms and Conditions of Sale',
  hideInMainNav: true,
  routeProps: {exact: true}
})(ImprintPage)
